import React, { memo, useEffect, useState } from 'react'
import makeStyles from 'transfix-ui/core/styles/makeStyles/makeStyles'
import theme from 'transfix-ui/theme/theme'
import { IShipperApplicationEdiConfig } from 'types/graphqlTypes'
import { ShipperEdiGeneralSettingsCard } from './ShipperEdiGeneralSettingsCard'
import { ShipperEdiInvoiceSettingsCard } from './ShipperEdiInvoiceSettingsCard'
import { ShipperEdiUpdateSettingsCard } from './ShipperEdiUpdateSettingsCard'
import { useShipperApplicationEdiConfigLazyQuery } from './graphql/ShipperApplicationEdiConfig'

interface IShipperEdiSettingsTabProps {
  id?: string | null
  shipperApplicationId?: string | null
}

const useShipperEdiSettingsTabStyles = makeStyles(() => ({
  card: {
    marginTop: theme.spacing(2),
  },
}))

export const ShipperEdiSettingsTab = memo<IShipperEdiSettingsTabProps>(
  ({ id, shipperApplicationId }) => {
    const classes = useShipperEdiSettingsTabStyles()
    const [shipperEdiConfig, setShipperEdiConfig] = useState<IShipperApplicationEdiConfig | null>()
    const [getShipperEdiConfig, { data }] = useShipperApplicationEdiConfigLazyQuery({
      variables: {
        id: String(id),
        shipperApplicationId: String(shipperApplicationId),
      },
      notifyOnNetworkStatusChange: true,
    })

    /* Loading the shipper application EDI configs when page loads */
    useEffect(() => {
      getShipperEdiConfig()
      setShipperEdiConfig(data?.shipperApplicationEdiConfig || null)
    }, [data?.shipperApplicationEdiConfig, getShipperEdiConfig])

    const {
      ediEnabled,
      ediInvoicing,
      id: configId,
      sendsAppointmentMessagesOnlyWhenConfirmed,
      sendsAppointmentTimesOnShipmentCreation,
      shipperRateUpdatesAllowed,
      statusTimezoneScheme,
    } = shipperEdiConfig || {}

    return (
      <div>
        <ShipperEdiGeneralSettingsCard configId={configId} ediEnabled={ediEnabled} />
        <div className={classes.card}>
          <ShipperEdiInvoiceSettingsCard configId={configId} ediInvoicing={ediInvoicing} />
        </div>
        <div className={classes.card}>
          <ShipperEdiUpdateSettingsCard
            configId={configId}
            statusTimezoneScheme={statusTimezoneScheme}
            sendsAppointmentMessagesOnlyWhenConfirmed={sendsAppointmentMessagesOnlyWhenConfirmed}
            sendsAppointmentTimesOnShipmentCreation={sendsAppointmentTimesOnShipmentCreation}
            shipperRateUpdatesAllowed={shipperRateUpdatesAllowed}
          />
        </div>
      </div>
    )
  }
)
